/* Carry the shared vehicle selection through the theme's native search flows. */
(() => {
  'use strict';
  if (window.FramewerkSearchVehicle) return;
  const filter = 'filter.p.m.framewerk_catalogue_spike.compatibility_tokens';
  const isSearch = url => /\/search\/?$/.test(url.pathname) && url.origin === location.origin;
  function selected() {
    const current = window.Framewerk?.vehicle?.get?.();
    if (current) return current;
    try {
      const saved = localStorage.getItem('framewerk:vehicle:v1');
      // An explicit clear must not resurrect a legacy vehicle.
      const value = saved === null ? localStorage.getItem('framewerk:mister-fitment:selected-vehicle') : saved;
      return value === null ? undefined : JSON.parse(value);
    } catch { return undefined; }
  }
  function buildUrl(href, vehicle = selected()) {
    const url = new URL(href, location.origin);
    if (!isSearch(url) || vehicle === undefined) return url;
    if (window.Framewerk?.catalogue?.buildUrl) return new URL(window.Framewerk.catalogue.buildUrl(vehicle, url.href));
    // Forms can be submitted before the deferred app embed is ready. Use its
    // existing Shopify projection contract until the shared API takes over.
    const code = String(vehicle?.code || vehicle?.vehicleCode || '').trim();
    if (vehicle && !code) return url;
    const before = url.searchParams.getAll(filter);
    const values = before.filter(value => value !== 'universal' && !value.startsWith('vehicle:'));
    if (code) values.push('vehicle:' + code);
    const desired = [...new Set(values)];
    if (JSON.stringify([...before].sort()) !== JSON.stringify([...desired].sort())) url.searchParams.delete('page');
    url.searchParams.delete(filter);
    desired.forEach(value => url.searchParams.append(filter, value));
    return url;
  }
  window.FramewerkSearchVehicle = Object.freeze({ buildUrl });
  document.addEventListener('formdata', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.method.toLowerCase() !== 'get') return;
    const url = new URL(form.action, location.href);
    if (!isSearch(url)) return;
    const data = event.formData;
    url.search = new URLSearchParams([...data].filter(([, value]) => typeof value === 'string')).toString();
    const destination = buildUrl(url);
    data.delete(filter);
    destination.searchParams.getAll(filter).forEach(value => data.append(filter, value));
    if (!destination.searchParams.has('page')) data.delete('page');
  }, true);
  let queued = false;
  let navigating;
  function reconcile(replace = false, vehicle = selected()) {
    if (!isSearch(new URL(location.href))) return;
    const destination = buildUrl(location.href, vehicle);
    const normalise = href => { const url = new URL(href); url.searchParams.sort(); return url.href; };
    if (normalise(destination) === normalise(location.href) || navigating === destination.href) return;
    navigating = destination.href;
    if (replace) location.replace(destination.href); else location.assign(destination.href);
  }
  let changedVehicle;
  function vehicleChanged(event) {
    changedVehicle = event.detail;
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; reconcile(false, changedVehicle); });
  }
  window.addEventListener('framewerk:vehicle:changed', vehicleChanged);
  window.addEventListener('framewerk:ready', () => reconcile(true));
  window.addEventListener('pageshow', () => { navigating = undefined; reconcile(true); });
  // Repair old/bookmarked search links, including restored pages, without
  // adding a second history entry. Subsequent submits already carry the filter.
  reconcile(true);
})();
